(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"), require("Vuex"), require("Vuetify"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue", "Vuex", "Vuetify"], factory);
	else if(typeof exports === 'object')
		exports["LexWebUi"] = factory(require("Vue"), require("Vuex"), require("Vuetify"));
	else
		root["LexWebUi"] = factory(root["Vue"], root["Vuex"], root["Vuetify"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE_vue__, __WEBPACK_EXTERNAL_MODULE_vuex__, __WEBPACK_EXTERNAL_MODULE_vuetify__) => {
return 